export default __webpack_public_path__ + "static/media/2018_Ke_and_Letten_2018_NatureEcolEvol.104b8ee8.pdf";